import {
  Shoes,
  BlackDumbell,
  DistanceWalked,
  Fire,
  MuscleMass,
  FatFreeWeight,
  BloodPressure,
  HeartRate,
  BodyFatPercentage,
  BMI,
  Weight,
  SleepDuration,
} from "@utils/defaultImages";
import { useTranslation } from "react-i18next";

export const getStatCards = (summary = {} , t) => {
  return [
    {
      label: t("Total Steps"),
      value: summary?.totalSteps ?? 0,
      color: "#FFF7F0",
      icon: <Shoes />,
    },
    {
      label: t("Active Time"),
      value: summary?.activeTime ?? "0m",
      color: "#F4F4F4",
      icon: <BlackDumbell />,
    },
    {
      label: t("Distance"),
      value: summary?.distance ?? "0 km",
      color: "#F4FFF0",
      icon: <DistanceWalked />,
    },
    {
      label: t("Calories Burnt"),
      value: summary?.caloriesBurnt ?? 0,
      color: "#FFFAF0",
      icon: <Fire />,
    },
  ];
};

export const getDeviceCards = (summary = {} , t) => {
  return [
    {
      label: t("Sleep duration"),
      value: summary?.sleep_minutes,
      color: "#F0FFFF",
      icon: <SleepDuration />,
    },
    {
      label: t("Weight"),
      value: summary?.weight,
      color: "#FFF0FB",
      icon: <Weight />,
    },
    {
      label: t("Body Fat %"),
      value: summary?.body_fat_percentage,
      color: "#FDFFF0",
      icon: <BodyFatPercentage />,
    },
    {
      label: t("Muscle Mass"),
      value: summary?.muscle_mass_kg,
      color: "#F0F5FF",
      icon: <MuscleMass />,
    },
    {
      label: t("Fat-Free Weight"),
      value: summary?.fat_free_mass_kg,
      color: "#FEF0FF",
      icon: <FatFreeWeight />,
    },
    {
      label: t("BMI"),
      value: summary?.bmi,
      color: "#F0FFF4",
      icon: <BMI />,
    },
    {
      label: t("Heart Rate"),
      value: summary?.heart_rate,
      color: "#FFF6F0",
      icon: <HeartRate />,
    },
    {
      label: t("Blood Pressure"),
      value: summary?.blood_pressure,
      color: "#FFF0F0",
      icon: <BloodPressure />,
    },
  ];
};
